"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var fallback_1 = __importDefault(require("@seaweb/coral/utils/fallback"));
var SelectContext_1 = require("./SelectContext");
var ValueWrapper = styled_1.default.div.attrs({ 'data-coral-select-selected-content': '' })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-grow: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n\n  ", "\n\n  ", "\n\n  .coral-select-highlighter__highlight {\n    color: inherit;\n  }\n"], ["\n  flex-grow: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n\n  ",
    "\n\n  ",
    "\n\n  .coral-select-highlighter__highlight {\n    color: inherit;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.colors.alternate);
}, function (_a) {
    var disabled = _a.disabled;
    return disabled && styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      opacity: 0.4;\n    "], ["\n      opacity: 0.4;\n    "])));
});
var Placeholder = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  flex-grow: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  opacity: 0.4;\n\n  ", "\n"], ["\n  flex-grow: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  opacity: 0.4;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return styled_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.colors.alternate);
});
var SelectSelectedContent = function (_a) {
    var children = _a.children, placeholder = _a.placeholder, disabled = _a.disabled;
    var _b = SelectContext_1.useSelectContext(), optionChilds = _b.optionChilds, value = _b.value;
    if (value === null && placeholder) {
        return react_1.default.createElement(Placeholder, null, placeholder);
    }
    return react_1.default.createElement(ValueWrapper, { disabled: disabled }, fallback_1.default(children, optionChilds.get(value)));
};
exports.default = react_1.memo(SelectSelectedContent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
